import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import { serverType, Server } from '../types/server'
import {
  serverQueryArgsType,
  ServerQueryArgs
} from '../types/server-query-args'
import { findByIDAndOrganizationID } from './helpers/server'

export const server: GraphQLFieldConfig<any, Context, ServerQueryArgs> = {
  description: 'Get a server by ID and Organization ID',
  type: new GraphQLNonNull(serverType),
  args: serverQueryArgsType,
  resolve(_source, args, context): Promise<Partial<Server>> {
    const { organizationID, serverID } = args

    return findByIDAndOrganizationID(
      serverID,
      organizationID,
      context.connector
    )
  }
}
